import styled from "styled-components";
import { inputBorderColor } from "@app/styles";
import { labelColor, newsecondaryColor } from "../../styles/colors";

type Props = {
  disabled?: boolean;
};

export const LayoutContainer = styled.div`
  display: flex;
  width: 100%;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  align-content: flex-start;
  justify-content: center;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  align-content: flex-start;
  flex: 1;
  &.signUps {
    overflow: auto;
    justify-content: flex-start;
  }
  @media (max-width: 575px){
    justify-content: flex-start;
  }
`;
export const SignLayout = styled.div`
  background-color: #fff;
  padding: 48px 64px;
  box-sizing: border-box;
  border-radius: 10px;
  width: 100%;
  border-radius: 12px;
  max-width: 680px;
  margin: 30px auto;
  position: relative;
  z-index: 1;
  .leaf-bg-image {
    position: absolute;
    top: -100px;
    left: -150px;
    z-index: -1;
    @media (max-width: 575px) {
      top: -40px;
      left: -100px;
    }
  }
  &.home {
    padding: 48px;
    max-width: 900px;
    @media (max-width: 575px) {
      max-width: calc(100vw - 16px);
      padding: 32px;
    }
  }
  h1 {
    text-align: center;
    margin-bottom: 8px;
    margin-top: 0;
    font-style: normal;
    font-weight: 500;
    font-size: 36px;
    line-height: 1.4;
    text-align: center;
    color: #00be9a;
    &.common {
      font-style: normal;
      font-weight: 500;
      font-size: 28px;
      line-height: 32px;
    }
  }
  h2 {
    color: #016bb5;
    margin-bottom: 10px;
    margin-top: 0;
    font-weight: 500;
    font-size: 21px;
    font-style: normal;
    font-weight: 500;
    font-size: 28px;
    line-height: 32px;
  }
  .left-aligned-image {
    position: absolute;
    top: 50%;
    left: -170px;
    transform: translateY(-50%);
  }
  .right-aligned-image {
    position: absolute;
    top: 50%;
    right: -170px;
    transform: translateY(-50%);
  }
  &.h-300 {
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &.center-sec {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  @media (max-width: 575px) {
    max-width: 350px;
    padding: 32px;
  }
  &.forgot-pwd-container {
    width: 500px;
    height: 400px;
    @media (max-width: 575px) {
      display: flex;
      padding: 48px 24px;
      height: unset;
    }
  }
`;

export const OptionCardsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const OptionCard = styled.a`
  height: 60px;
  display: flex;
  cursor: pointer;
  flex-direction: row;
  align-items: center;
  background: #ffffff;
  border: solid 1.5px ${inputBorderColor};
  border-radius: 6px;
  span {
    font-weight: 500;
  }
  &:hover {
    border: solid 1.5px ${newsecondaryColor};
    background-color: rgb(0 190 154 / 10%);
    span {
      color: ${newsecondaryColor};
    }
  }
  &:not(:last-child) {
    margin-bottom: 16px;
  }
`;

export const ImageHolder = styled.div`
  width: 42px;
  height: 42px;
  border: 1px solid #b9b9b9;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 8px;
`;

export const LayoutLogo = styled.div`
  padding-bottom: 16px;
  text-align: center;
  padding-top: 16px;
  // background-color: #e9f3f1;
  img {
    cursor: pointer;
  }
`;
export const InfoSection = styled.div`
  width: 50%;
  padding-left: 48px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  h2 {
    font-style: normal;
    font-weight: 500;
    font-size: 28px;
    line-height: 32px;
    color: ${newsecondaryColor};
  }
  .description {
    font-size: 16px;
    line-height: 28px;
    letter-spacing: 0.035em;
    color: ${newsecondaryColor};
  }
  .circle-sec {
    display: flex;
    margin: 30px 0;
    align-items: center;
  }
  .circle {
    width: 8px;
    height: 8px;
    background: ${newsecondaryColor};
    opacity: 0.5;
    border-radius: 50%;
    cursor: pointer;
    &.active {
      border: 1px solid #ffffff;
      box-shadow: 0 0 0 1px #00be9a;
      box-sizing: border-box;
      height: 12px;
      width: 12px;
      opacity: 1;
    }
    &:not(:last-child) {
      margin-right: 10px;
    }
  }
  @media (max-width: 575px){
    display: none;
  }
`;

export const RouteSection = styled.div`
  width: 50%;
  padding-right: 48px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  ::after {
    content: " ";
    width: 1px;
    position: absolute;
    right: 0;
    height: 100%;
    background: ${inputBorderColor};
    @media (max-width: 575px){
      display: none;
    }
  }
  .info-with-icon {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    padding-right: 16px;
    span {
      flex: 1;
      font-style: normal;
      font-weight: 300;
      font-size: 14px;
      line-height: 1.45;
      letter-spacing: 0.035em;
      color: ${labelColor};
      padding-right: 16px;
      @media (max-width: 575px){
        line-height: 20px;
      }
    }
    svg {
      height: 24px;
    }
  }
  @media (max-width: 575px){
    width: 100%;
    padding: 0;
  }
`;

export const GoogleImageHolder = styled.div`
  img{
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
`;
